import React, { useRef } from "react";
import { RouteComponentProps } from "@reach/router"
import {
  Card,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  styled,
  Toolbar,
} from '@material-ui/core';
import { VariableSizeList as List } from 'react-window';
import useResizeAware from 'react-resize-aware';


import { StringParam, useQueryParams } from "use-query-params";

import AppPage from "../../components/AppFrame/AppPage";

import { actions } from '../../services/chats';
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { RootState } from "../../store";
import ChatMessage from "./ChatMessage";



const RootList = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  position: 'relative',
});

const Chats: React.FC<RouteComponentProps> = () => {
  const dispatch = useDispatch();
  const state = useSelector((state: RootState) => state.chats);
  const [ resizeListener, size ] = useResizeAware();

  const listRef = useRef(null);

  const [ filters, setFilters ] = useQueryParams({
    type: StringParam
  });

  const handleFilterChange = (event: SelectChangeEvent<string>) => {
    setFilters({
      [ event.target.name ]: event.target.value
    }, 'replaceIn');
  };


  useEffect(() => {
    listRef.current && (listRef as any).current.resetAfterIndex(0, false);
    dispatch(actions.loadMessages(filters.type || 'all'));

    return () => {
      dispatch(actions.resetMessages());
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ filters ]);


  return (
    <AppPage title="Chats" loading={state.messagesLoading}>
      
        <Card variant="outlined" sx={{ width: '100%', padding: '10px 0px' }}>
          <Toolbar>
            <FormControl sx={{ minWidth: 120 }}>
              <InputLabel id="type-label">Message Type</InputLabel>
              <Select
                name="type"
                labelId="type-label"
                value={filters.type || 'all'}
                label="Message Type"
                onChange={handleFilterChange}
              >
                <MenuItem value="all">All</MenuItem>
                <MenuItem value="text">Text</MenuItem>
                <MenuItem value="photo">Photo</MenuItem>
                <MenuItem value="voice">Voice</MenuItem>
                <MenuItem value="giphy">Giphy</MenuItem>
                <MenuItem value="sticker">Sticker</MenuItem>
              </Select>
            </FormControl>
          </Toolbar>
        </Card>
        <RootList>
          {resizeListener}

          <List
            height={(size.height || 50) - 10}
            width={size.width || 0}
            itemCount={state.messages.length > 0 ? state.messages.length + 1 : 0}
            itemSize={(index) => {
              if (index < state.messages.length && [ 'photo', 'giphy' ].includes(state.messages[ index ].type)) {
                return 150;
              }
              if (index < state.messages.length && [ 'voice' ].includes(state.messages[ index ].type)) {
                return 100;
              }
              return 70;
            }}
            itemData={state.messages}
            ref={listRef}
          >
            {ChatMessage}
          </List>

        </RootList>
      
    </AppPage>
  );
};

export default Chats;